/* Akun pengeluaran (CoA) — 30 Okt 2026.
   Angka depan kode = kelompok: 1 Belanja Aset (bukan biaya bulanan), 5 Biaya Operasional,
   6 Biaya Karyawan, 9 Bukan Biaya. Yang disimpan di baris kas adalah NAMA akun.

   DAFTAR INI HARUS SAMA dengan KAS_AKUN_KELUAR di backend/server.py.
   Dijaga oleh uji/uji_coa.py — kalau salah satu diubah, ubah dua-duanya. */
export const KELOMPOK_AKUN = {
  aset: { kode: '1', nama: 'Belanja Aset', arti: 'dipakai lama (stok busana, peralatan) — bukan biaya bulanan' },
  operasional: { kode: '5', nama: 'Biaya Operasional', arti: 'habis dipakai menjalankan usaha' },
  karyawan: { kode: '6', nama: 'Biaya Karyawan', arti: 'gaji dan tunjangan' },
  bukan: { kode: '9', nama: 'Bukan Biaya', arti: 'uang keluar yang bukan beban usaha' },
};

export const AKUN_KELUAR = [
  { kode: '1-10', nama: 'Pembelian Stock Busana & Aksesoris', kelompok: 'aset' },
  { kode: '1-11', nama: 'Ongkir Pembelian Stock', kelompok: 'aset' },
  { kode: '1-20', nama: 'Peralatan & Renovasi Toko', kelompok: 'aset' },
  { kode: '5-11', nama: 'Listrik (PLN)', kelompok: 'operasional' },
  { kode: '5-12', nama: 'Internet & Pulsa', kelompok: 'operasional' },
  { kode: '5-13', nama: 'Langganan Aplikasi & Server', kelompok: 'operasional' },
  { kode: '5-21', nama: 'Jasa Laundry', kelompok: 'operasional' },
  { kode: '5-22', nama: 'Kebersihan & Perawatan Busana', kelompok: 'operasional' },
  { kode: '5-23', nama: 'Packaging', kelompok: 'operasional' },
  { kode: '5-24', nama: 'Perlengkapan Toko', kelompok: 'operasional' },
  { kode: '5-31', nama: 'Transportasi & Ongkir', kelompok: 'operasional' },
  { kode: '5-32', nama: 'Perbaikan & Perawatan', kelompok: 'operasional' },
  { kode: '5-41', nama: 'Iklan & Promosi', kelompok: 'operasional' },
  { kode: '5-51', nama: 'Konsumsi', kelompok: 'operasional' },
  { kode: '5-61', nama: 'Admin Bank', kelompok: 'operasional' },
  { kode: '6-11', nama: 'Gaji', kelompok: 'karyawan' },
  { kode: '6-12', nama: 'Uang Makan & Tunjangan', kelompok: 'karyawan' },
  { kode: '9-10', nama: 'Pengembalian DP ke Customer', kelompok: 'bukan' },
  { kode: '9-20', nama: 'Prive / Pemakaian Pribadi', kelompok: 'bukan' },
  { kode: '9-30', nama: 'Utang Pemilik', kelompok: 'bukan' },
  { kode: '9-40', nama: 'Pinjaman ke Orang Lain', kelompok: 'bukan' },
  { kode: '9-99', nama: 'Lainnya', kelompok: 'bukan' },
];

export const OUT_CATS = AKUN_KELUAR.map((a) => a.nama);
export const URUTAN_KELOMPOK = ['aset', 'operasional', 'karyawan', 'bukan'];

/* Info satu kategori. Nama lama yang belum dirapikan -> { lama: true }. */
export function infoAkun(nama) {
  const a = AKUN_KELUAR.find((x) => x.nama === nama);
  return a ? { ...a, lama: false } : { kode: '', nama: nama || '', kelompok: '', lama: true };
}

/* Pilihan akun untuk <select>: dikelompokkan, hanya NAMA yang tampil (kode di laporan). */
export function AkunOptions({ tambahan }) {
  return (
    <>
      {tambahan && !AKUN_KELUAR.some((a) => a.nama === tambahan) && (
        <option value={tambahan}>{tambahan} (kategori lama)</option>
      )}
      {URUTAN_KELOMPOK.map((k) => (
        <optgroup key={k} label={KELOMPOK_AKUN[k].nama}>
          {AKUN_KELUAR.filter((a) => a.kelompok === k).map((a) => (
            <option key={a.nama} value={a.nama}>{a.nama}</option>
          ))}
        </optgroup>
      ))}
    </>
  );
}
